import React from 'react';

import { FaCar } from 'react-icons/fa';
import { ReactComponent as BikeIcon } from '../../../assets/newsvg/bike.svg';
import Modal from '../../../components/modals/Modal';

import './ETAOptionsModal.scss';
import { PredictionModel, TravelMode } from '../../../types/bundleTypes';
import Fetch from '../../../utils/fetch';
import { settings } from '../../../settings';
import { queryStringFromObject } from 'utils/urlUtil';
import { Region } from '../../../types/orderTypes';

interface Props {
  onCloseModal: () => void;
  onTravelModeSelected: (travelMode: TravelMode, timePerStop: number) => void;
  region: Region;
  predictionModel: string;
}

interface State {
  selected: TravelMode;
  timePerStop: string;
}

interface RoutingStorage {
  timePerStopMinutes: number;
}

export default class ETAOptionsModal extends React.Component<Props, State> {
  private static readonly DEFAULT_TIME_PER_STOP_MINUTES = 4;

  constructor(props: Props) {
    super(props);

    this.state = {
      selected: TravelMode.NONE,
      timePerStop: '',
    };
  }

  async componentDidMount() {
    const timePerStop = await this.fetchRoutingTimePerStop();
    this.setState({ timePerStop: timePerStop.toString() });
  }

  async fetchRoutingTimePerStop(): Promise<number> {
    const queryParams = queryStringFromObject({
      region: this.props.region,
    });
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/bundle/routing-info${queryParams}`,
    });
    const routingInfo: RoutingStorage = response.ok
      ? await response.json()
      : null;
    return (
      (routingInfo && routingInfo.timePerStopMinutes) ||
      ETAOptionsModal.DEFAULT_TIME_PER_STOP_MINUTES
    );
  }

  render() {
    const timePerStop = parseInt(this.state.timePerStop);
    const validTimePerStop = !isNaN(timePerStop) && timePerStop >= 0;
    return (
      <Modal
        title="Calculate bundle ETAs"
        onClose={() => this.props.onCloseModal()}
        buttons={[
          {
            title: (
              <div className="eta-options-modal-content__buttons">
                <span>Bicycle</span> <BikeIcon />
              </div>
            ),
            className: 'eta-options-modal-content__bike-button',
            onClick: () =>
              this.props.onTravelModeSelected(
                TravelMode.BIKE,
                parseInt(this.state.timePerStop)
              ),
            disabled: !validTimePerStop,
          },
          {
            title: (
              <div className="eta-options-modal-content__buttons">
                <span>Car</span> <FaCar />
              </div>
            ),
            className: 'eta-options-modal-content__car-button',
            onClick: () =>
              this.props.onTravelModeSelected(
                TravelMode.CAR,
                parseInt(this.state.timePerStop)
              ),
            disabled: !validTimePerStop,
          },
        ]}
      >
        {!!this.props.predictionModel &&
        this.props.predictionModel !== '' &&
        (this.props.predictionModel === PredictionModel.NeuralNetworkOSRM ||
          this.props.predictionModel === PredictionModel.DecisionTreeOSRM ||
          this.props.predictionModel === PredictionModel.NeuralNetwork ||
          this.props.predictionModel === PredictionModel.DecisionTree) ? (
          <div className="eta-options-modal-content">
            <div className="eta-options-modal-desc">
              The assigned courier uses eta predictions (
              {this.props.predictionModel}), you can't set a stop time.
            </div>
          </div>
        ) : (
          <div className="eta-options-modal-content">
            <div className="eta-options-modal-desc">
              Select a travel mode to calculate the bundle ETAs.
            </div>
            <div className="travel-time-per-stop">
              <span>Waiting time per stop: </span>
              <input
                type="text"
                name="timePerStop"
                autoFocus={true}
                maxLength={2}
                onChange={event =>
                  this.setState({ timePerStop: event.target.value })
                }
                value={this.state.timePerStop}
              />{' '}
              <small>minutes</small>
            </div>
            <div>
              <small>
                The ETAs will be re-calculated again when this bundle is
                assigned to a courier.
              </small>
            </div>
          </div>
        )}
      </Modal>
    );
  }
}
